module.exports = __webpack_public_path__ + "img/sa-flag-icon.87d9094c.svg";